import { toTitleCase } from "@/lib/strings";

const ActivityReportTextDialog = ({ l11n, assessment, uiIsRtl, targLangIsRtl }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        // backgroundColor: "green",
      }}
      className="px-3 mt-4"
    >
      <Recap
        uiLang={assessment.scriptLang}
        l11n={l11n}
        messageLog={assessment.module.messageLog || []}
        uiIsRtl={uiIsRtl}
        targLangIsRtl={targLangIsRtl}
      />
      <VocabSection
        l11n={l11n}
        vocab={assessment.module.xp.vocab_words || []}
        uiIsRtl={uiIsRtl}
        targLangIsRtl={targLangIsRtl}
      />
    </div>
  );
};

// MARK: Recap
const Recap = ({ uiLang, l11n, messageLog, uiIsRtl, targLangIsRtl }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
    <div
      style={{
        padding: "0px 6px",
        fontSize: "24px",
        fontWeight: "bold",
        textTransform: "uppercase",
        textAlign: uiIsRtl ? "right" : "left",
        direction: uiIsRtl ? "rtl" : "ltr",
      }}
    >
      {l11n.dialog_review}
    </div>
    <hr
      style={{
        width: "100%",
        border: "0.5px solid rgb(107, 107, 107)",
      }}
      className="mb-4"
    />
    <div>
      {messageLog.map((entry, index) => (
        <MessageLogEntry
          key={index}
          uiLang={uiLang}
          l11n={l11n}
          entry={entry}
          uiIsRtl={uiIsRtl}
          targLangIsRtl={targLangIsRtl}
        />
      ))}
    </div>
  </div>
);

// MARK: MessageLogEntry
const MessageLogEntry = ({ uiLang, l11n, entry, uiIsRtl, targLangIsRtl }) => {
  if (!entry.content) return null;
  const isUser = entry.role === "user";
  const userTag = isUser ? l11n.you : "Taalia";
  const commentary = entry.metadata?.annotation?.[uiLang];

  const messageBubbleIsRtl = targLangIsRtl;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: isUser ? "flex-end" : "flex-start",
        gap: "4px",
        marginBottom: "12px",
      }}
    >
      <div style={{ fontSize: "10px", color: "rgb(112, 112, 112)" }}>{userTag}</div>
      <div
        style={{
          backgroundColor: isUser ? "rgb(27, 151, 243)" : "rgb(232, 232, 238)",
          color: isUser ? "white" : "black",
          padding: "8px 16px",
          borderRadius: "10px",
          maxWidth: "75%",
          textAlign: messageBubbleIsRtl ? "right" : "left",
          direction: messageBubbleIsRtl ? "rtl" : "ltr",
          wordWrap: "break-word",
          overflowWrap: "break-word",
          whiteSpace: "pre-wrap",
        }}
      >
        {entry.content}
      </div>
      {isUser && commentary && (
        <CommentaryBubble commentary={commentary} uiIsRtl={uiIsRtl} />
      )}
    </div>
  );
};

// MARK: CommentaryBubble
const CommentaryBubble = ({ commentary, uiIsRtl }) => (
  <div
    style={{
      maxWidth: "75%",
      padding: "4px 8px",
      borderRadius: "5px",
      marginTop: "4px",
      textAlign: uiIsRtl ? "right" : "left",
      direction: uiIsRtl ? "rtl" : "ltr",
      border: "1px solid rgb(187, 99, 4)",
      color: "rgb(187, 99, 4)",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      whiteSpace: "pre-wrap",
    }}
  >
    {commentary}
  </div>
);

// MARK: VocabSection
const VocabSection = ({ l11n, vocab, uiIsRtl, targLangIsRtl }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
    <div
      style={{
        padding: "0px 6px",
        fontSize: "24px",
        fontWeight: "bold",
        textTransform: "uppercase",
        textAlign: uiIsRtl ? "right" : "left",
        direction: uiIsRtl ? "rtl" : "ltr",
      }}
    >
      {l11n.vocab}
    </div>
    <hr
      style={{
        width: "100%",
        border: "0.5px solid rgb(107, 107, 107)",
      }}
      className="mb-4"
    />
    <div>
      {vocab.map((entry, index) => (
        <div key={index}>
          <VocabEntry entry={entry} uiIsRtl={uiIsRtl} targLangIsRtl={targLangIsRtl} />
          {index < vocab.length - 1 && (
            <hr style={{ border: "0.5px solid rgb(232, 232, 238)", margin: "8px 0" }} />
          )}
        </div>
      ))}
    </div>
  </div>
);

// MARK: VocabEntry
const VocabEntry = ({ entry, uiIsRtl, targLangIsRtl }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "0px",
      textAlign: uiIsRtl ? "right" : "left",
      direction: uiIsRtl ? "rtl" : "ltr",
      fontSize: "12px",
    }}
  >
    <div
      style={{ display: "flex", gap: "4px", lineHeight: "1.2", alignItems: "flex-end" }}
    >
      <div style={{ fontSize: "16px", fontWeight: "bold" }}>
        {toTitleCase(entry.word)}{" "}
        <span style={{ fontSize: "11px" }}>({entry.partOfSpeech})</span>
      </div>
    </div>
    <div>{entry.definition}</div>
    <div>{entry.comment}</div>
    <div
      style={{
        direction: targLangIsRtl ? "rtl" : "ltr",
      }}
    >
      &quot;{entry.example}&quot;
    </div>
  </div>
);

export default ActivityReportTextDialog;
